import { CellTable } from "@/atoms"
import { ScanStateIndicator } from "../ScanStateIndicator"

import type { ApplicationNameCellComponent } from "."

export const ApplicationNameCell: ApplicationNameCellComponent = (
  name,
  record
) => (
  <ScanStateIndicator scanState={record.scanState}>
    {CellTable(name, record)}
  </ScanStateIndicator>
)
